import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Pierrick Lotton",
  title: "Research Scientist at CNRS / Le Mans University",
  description: `
Pierrick Lotton was born in France in 1967. He fisrt studied electronics at the University of Rennes and then acoustics at Le Mans University where he graduated (1991) and received his Ph.D. degree in Acoustics (1994). Since 1995, he has been a CNRS research fellow at the Acoustic Laboratory of Le Mans University (LAUM, UMR 6613). His research interests mainly concern electroacoustic transducers (encompassing their modeling, development, and experimental characterization across various types of transducers, as well as the study of transducer nonlinearities) and thermoacoustics (acoustic refrigeration, study of transient and nonlinear processes, miniaturization). From 2016 to 2021, he was the Head of the LAUM, overseeing a team of 170 individuals spanning three research groups. Up to now, he published 50 papers in international peer reviewed journals. He is a member of the French Acoustical Society (SFA), the European Acoustics Association (EAA) and the Audio Engineering Society (AES).



  <ul>
    <li><a href="https://laum.univ-lemans.fr/en" target="_blank">Laum</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/avatar-placeholder.png",
};

export default author;
